;(function() {
  jQuery(document).ready(function () {

	var top = jQuery('#announcement-bar').outerHeight()
	jQuery('#header').css("top", `${top}px`)

    const navToggle = jQuery('#slide-out-side-menu');
    const navMenu = jQuery('#slide-side-menu');
    const menuWithScroll = jQuery('#slide-side-menu .menu');
    const buttonNavClose = jQuery('#slide-in-side-menu');

    navToggle.on('click', function () {
    //   console.log('Safari hello');

    //   console.log(navMenu);

      if (navMenu.hasClass('active')) {
        bodyScrollLock.disableBodyScroll(menuWithScroll[0]);
      } else {
        bodyScrollLock.clearAllBodyScrollLocks();
      }
    });

    buttonNavClose.on('click', function () {
      if (!navMenu.hasClass('active')) {
        bodyScrollLock.clearAllBodyScrollLocks();
      }
    });

    jQuery(document).on('click touchstart', function (e) {
      if (jQuery(e.target).closest(navToggle.add(navMenu)).length) {
        return;
      }
      bodyScrollLock.clearAllBodyScrollLocks();
    });

  });
}());
;(function ($) {
	let $instagram = $('#instafeed');

	if ($instagram.length){
		let id = $instagram.data('user-id');
		let token = $instagram.data('access-token');
		let count = $instagram.data('count');

		if (id && token){
			let feed = new Instafeed({
				get: 'user',
				userId: id,
				limit: count,
				sortBy: 'most-recent',
				resolution: 'low_resolution',
				accessToken: token,
				template: `<div><div class="instagram__item"><div class="instagram__image-wrapper"><a href="{{link}}" target="_blank" class="instagram__image" style="background-image: url('{{image}}')"></a></div></div></div>`,
				after: function(){
					$('#instafeed').slick({
						slidesToShow: 4,
						slidesToScroll: 1,
						arrows: false,
						infinite: true,
						autoplay: true,
						autoplaySpeed: 2000,
						responsive: [
							{
								breakpoint: 768,
								settings: {
									slidesToShow: 2,
									slidesToScroll: 1
								}
							},
							{
								breakpoint: 480,
								settings: {
									slidesToShow: 1,
									slidesToScroll: 1
								}
							}
						]
					});
				}
			});

			feed.run();
		}
	}
})(jQuery);

;(function ($) {
	// $('.js-home-slider').slick({
	// 	slidesToShow: 4,
	// 	slidesToScroll: 1,
	// 	infinite: false,
	// 	responsive: [
	// 		{
	// 			breakpoint: 768,
	// 			settings: {
	// 				slidesToShow: 2,
	// 				slidesToScroll: 1
	// 			}
	// 		},
	// 		{
	// 			breakpoint: 480,
	// 			settings: {
	// 				slidesToShow: 1,
	// 				slidesToScroll: 1
	// 			}
	// 		}
	// 	]
	// });
})(jQuery);

;(function () {
    jQuery( document ).ready(function() {
        let slideWrapper = jQuery('.flickity-slider');
        let slideShow = jQuery('.section-block-slide');
        let slideshowButtons = jQuery('.flickity-prev-next-button');
        let slideShowDots = jQuery('.flickity-page-dots');

        if(slideShow.length <= 1){
            slideshowButtons.css('display', 'none');
            slideShowDots.css('display', 'none');

            slideShow.css('cursor', 'auto');

            slideWrapper.addClass('preventscrollx');
        }
    });
})();

let countryTr = '[data-address-country]'
function initProvinces(target) {
	let options = '';
	if(target) {
		options = $(target).find('option:selected').attr('data-provinces');
	} else {
		options = $(countryTr).find('option:selected').attr('data-provinces');
	}
	console.log(options)
	options = JSON.parse(options);
	if(options.length) {
		$('[data-address-province]').find('select').html('')
		options.forEach(item => {
			$('[data-address-province]').find('select').append(`
			<option value="${item[0]}">${item[0]}</option>
		`)
		})
		$('[data-address-province]').show()
	}
}
document.addEventListener('DOMContentLoaded', () => {
	if($(countryTr).length) {
		initProvinces();
	}
	initProvinces();
	$(countryTr).find('select').change(e => {
		initProvinces(e.target);
	})
})

if(window.location.pathname === '/') {
	document.querySelector('#app-body').style.paddingTop = 0;
}